// extracted by mini-css-extract-plugin
module.exports = {"root":"uidJZ","district":"_18sPF","selected":"_2xaL1"};